import { render, staticRenderFns } from "./CompareSect.vue?vue&type=template&id=98d706d4&"
import script from "./CompareSect.vue?vue&type=script&lang=js&"
export * from "./CompareSect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CA5\\PhpstormProjects\\te-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('98d706d4', component.options)
    } else {
      api.reload('98d706d4', component.options)
    }
    module.hot.accept("./CompareSect.vue?vue&type=template&id=98d706d4&", function () {
      api.rerender('98d706d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/indexPartials/CompareSect.vue"
export default component.exports